import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import PopupWarning from "./dialogs/PopupWarning";
import {useModal} from "./dialogs/ModalContext";

const appMap = new Map([
    ["test", 8000],
    ["askin", 8001],
    ["endored", 8002],
    ["fleximed", 8003],
    ["oculus", 8004],
    ["medecor", 8005],
]);

export function getAppName() {
    const port = parseInt(window.location.port)
    for (let [key, value] of appMap) {
        if (value === port) {
            return key
        }
    }
    return ""
}

export const useAxiosSetup = () => {
    // For production server we discern which app is used by port logic. Same dict is used in docker config to assing
    // correct backend.
    const navigate = useNavigate();
    const {showModal} = useModal();
    const isLocalhost = window.location.hostname === 'localhost'
    const isProxiedLocalhost = window.location.hostname === '192.168.1.10'
    const port = window.location.port
    let url = ''
    if (isLocalhost) {
        url = 'http://localhost:8000/'
    } else if (isProxiedLocalhost) {
        url = 'https://192.168.1.10:444/'
    } else {
        url = `https://${window.location.hostname}:${port}/backend/`
    }


    const api = axios.create({
        baseURL: url
        // other configurations
    });
    const requestInterceptor = api.interceptors.request.use(
        config => {
            const appName = getAppName()
            const user = localStorage.getItem(`${appName}_user`)
            const access = localStorage.getItem(`${appName}_access`)
            if (access) {
                config.headers.Authorization = `Bearer ${access}`;
            }
            if (user) {
                config.headers['Logged-User'] = user;
            }
            return config;
        },
        error => {
            Promise.reject(error)
        }
    );

    const responseInterceptor = api.interceptors.response.use(
        response => response,
        async error => {
            if (error.response.status === 401) {
                handleAuthentificationError(error);
            } else {
                handleCommonErrors(error);
            }
            return Promise.reject(error);
        }
    );

    function handleCommonErrors(error) {
        if (error.response.status === 500 && error.response.data.code) {
            let errorInfo = error.response.data.message
            if (error.response.data.details) {
                errorInfo += `\n\nDetaily:\n${error.response.data.details}`
            }
            showModal(PopupWarning, errorInfo, () => {
            })
        } else {
            const errorInfo = `Nastala Neočakávaná chyba.\n\n Kód chyby:\n${error.code}\n\nPopis chyby:\n${error.response.data}`
            showModal(PopupWarning, errorInfo, () => {
            })
        }
    }


    function handleAuthentificationError(error) {
        const originalRequest = error.config;
        const appName = getAppName()
        let isRetry = false;
        if (originalRequest.data && typeof originalRequest.data === 'string') {
            isRetry = originalRequest.data.includes('"_retry":true');
        }
        if (!isRetry) {
            const refresh = localStorage.getItem(`${appName}_refresh`);

            if (refresh && refresh !== "") {
                return api.post('api/token/refresh/', {refresh, _retry: true})
                    .then((response) => {
                        localStorage.setItem(`${appName}_refresh`, response.data.refresh)
                        localStorage.setItem(`${appName}_access`, response.data.access)
                        api.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;
                        originalRequest.headers.Authorization = `Bearer ${response.data.access}`;
                        return api(originalRequest); // Retry the original request with the new token
                    })
                    .catch(
                        (error) => {
                            localStorage.removeItem('refresh');
                            localStorage.removeItem('access');
                            showModal(PopupWarning, "Platnosť prihlásenia vypršala. Prihláste sa znova.", () => {
                                navigate('/login');
                            });
                        }
                    );
            } else {
                localStorage.removeItem('refresh');
                localStorage.removeItem('access');
                showModal(PopupWarning, "Platnosť prihlásenia vypršala. Prihláste sa znova.", () => {
                    navigate('/login');
                });
            }
        }
    }

    useEffect(() => {
        return () => {
            // Cleanup logic: remove interceptors
            api.interceptors.request.eject(requestInterceptor);
            api.interceptors.response.eject(responseInterceptor);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    // Expose the configured api instance
    return api;
};
